window.use_jwt_persistence = true;

export {};
